import UnfoldLessIcon from "@mui/icons-material/UnfoldLess";
import UnfoldMoreIcon from "@mui/icons-material/UnfoldMore";
import { IconButton, Tooltip } from "@mui/material";
import {
  COLLAPSE_ALL_LABEL,
  EXPAND_ALL_LABEL,
} from "../readmission-f2f-constant";

export interface ExpandCollapseAllButtonProps {
  isAllExpanded: boolean;
  onToggle: () => void;
}

const ExpandCollapseAllButton = ({
  isAllExpanded,
  onToggle,
}: ExpandCollapseAllButtonProps) => {
  const label = isAllExpanded ? COLLAPSE_ALL_LABEL : EXPAND_ALL_LABEL;

  return (
    <Tooltip title={label}>
      <IconButton size="small" aria-label={label} onClick={onToggle}>
        {isAllExpanded ? <UnfoldLessIcon /> : <UnfoldMoreIcon />}
      </IconButton>
    </Tooltip>
  );
};

export default ExpandCollapseAllButton;
